import { Box, Stack, useTheme, useMediaQuery } from "@mui/material";
import { ScoreComparisonCard } from "src/components/Actions/Tabs/ScoreComparisonCard";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { useEntityScores } from "src/context/Scores/useEntityScores";

export const SynthesisCards = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { scoresWithVariations, lastSelectedVariation } = useEntityScores();
    const { scoresEnabled, actionPlanData } = useActionsContext();

    return (
        <Stack flexDirection={"row"} flexWrap={"wrap"} gap={theme.spacing(1)}>
            {scoresEnabled.map((score) => {
                const scoreOpts = scoresWithVariations.filter((scoreVariation) => scoreVariation.scoreId === score.id);
                const selectedScore = scoreOpts.find((filteredScore) => {
                    const variationId = lastSelectedVariation.variationId ?? null;
                    const doesVariationMatch = variationId === filteredScore.variationId;
                    const doesScoreMatch = score.id === filteredScore.scoreId;
                    if (variationId === null) {
                        return doesScoreMatch;
                    }

                    return doesScoreMatch && doesVariationMatch;
                });

                if (scoreOpts.length === 0) return;
                const selectedOption = selectedScore ?? scoreOpts[0];

                const _actionPlanData = actionPlanData.find((i) => {
                    return i.scoreId === selectedOption.scoreId && i.variationId === selectedOption.variationId;
                });
                if (_actionPlanData === undefined) return;

                return (
                    <Box
                        key={`score-synthesis-${selectedOption.scoreId}-${selectedOption.variationId}`}
                        sx={{
                            display: "flex",
                            width: "49%",
                            flexDirection: "column",
                            [theme.breakpoints.down("md")]: {
                                width: "100%",
                            },
                        }}
                    >
                        <ScoreComparisonCard
                            position={isMobile ? "vertical" : "horizontal"}
                            actionPlanData={_actionPlanData}
                            selectedOption={selectedOption}
                            disableFooter
                            hideGoalWhenEmpty
                        />
                    </Box>
                );
            })}
        </Stack>
    );
};
